import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Components
import DataTable from "react-data-table-component";
import Layout from "../../../../Layout/Layout";
import Constants from "../../../../common/SupplierConstants";
import { SearchField } from "../../../../Components/formElements/SearchField";
import { formatDate, formatDateTime } from "../../../../common/Validations";

//Serivce

import {
  cashRequestNr,
  getCashRequest,
} from "../../../../redux/feature/customer_app/customerSlice";
import CustomerConstants from "../../../../common/CustomerConstants";
import CashRequestModel from "./CashRequestModel";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import CommonFilterCustomerV2 from "../Common/CommonFilterCustomerV2";
import TableActions from "../../../smart_construction_app/Customer_V4/Common/TableActions/TableActions";

const CashRequestList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  localStorage.setItem("menu", "Finance");
  localStorage.setItem("submenu", "Cash Request List");

  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  let cashData = useSelector((state) => state?.customer?.cashRequest); // User Details from Store

  let cashDataTable = useSelector(
    (state) => state?.customer?.cashRequest.pagination,
  ); // User Details from Store

  const [isCardVisible1, setCardVisible1] = useState(true);
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const [data, setData] = useState();
  // const filteredData = data?.filter(
  //   (item) =>
  //     item.cashRequestStatus === "Partial Amount" ||
  //     item.cashRequestStatus === "Cash in Transit"
  // );

  const [filterShow, setFilterShow] = useState(false);
  const [getFilter, setFilter] = useState({});

  const cashRequestInfo = [
    {
      name: "Cash Req",
      id: "documentNumber",
      selector: (row) => row?.documentNumber,
      cell: (row) => (
        <>
          <button
            className="btnInfo"
            onClick={() => detailedPage(row?.documentNumber)}
          >
            {row?.documentNumber || "-"}{" "}
          </button>
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Status",
      cell: (row) => (
        <>
          <TableStatusField status={`${row?.cashRequestStatus}`} />
        </>
      ),

      width: "180px",
    },
    {
      name: "Company",
      id: "companyCodeDesc",
      selector: (row) => row.companyCodeDesc,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.companyCodeDesc} </p>
          {/* <p className="m-0 p-0 ">{row.companyCodeDesc} </p> */}
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Customer",
      id: "customerName",
      selector: (row) => row.customerCode,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.customerName} </p>
          <p className="m-0 p-0 ">{row.customerCode} </p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Cash Amount",
      selector: (row) => row.cashAmount,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.cashAmount} </p>
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Payment Purpose",
      selector: (row) => row.paymentPurpose,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.paymentPurpose} </p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },

    {
      name: "Sales Officer",
      id: "salesOfficerName",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.salesOfficerName} </p>
          <p className="m-0 p-0 ">{row.salesOfficerCode} </p>
        </div>
      ),
      selector: (row) => row.salesOfficerName,
      sortable: true,
      width: "130px",
    },

    {
      name: "Create Date",
      selector: (row) => formatDateTime(row.cashRequestDate),
      cell: (row) => (
        <>
          <span>{formatDate(row.cashRequestDate)}</span>
        </>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Received By",
      selector: (row) => row.receivedBy,
      cell: (row) => (
        <>
          <span>{row.receivedBy}</span>
        </>
      ),
      sortable: true,
      width: "13s0px",
    },
    {
      name: "Action",
      cell: (row) => (
        <TableActions
          actions={[
            {
              label: "Edit",
              icon: "bi bi-pencil-square",
              iconClass: "text-success",
              bg: "#e6f7ee",
              // onClick: () => showAddProduct("EDIT", row.documentNumber),
            },
            {
              label: "Delete",
              icon: "bi bi-trash",
              iconClass: "text-danger",
              bg: "#fdeaea",
              // onClick: () => deleteMaterial(row),
            },
            {
              label: "More",
              icon: "bi bi-three-dots",
              bg: "#f1f3f5",
              // onClick: () => console.log("More", row),
            },
          ]}
        />
      ),
      width: "180px",
    },
  ];

  const loadInitialSuuplierData = async () => {
    setData(cashData?.data);
  };

  const handlePageChange = (page) => {
    let obj = {
      queryName: "getCashRequestList",
      module: "CUSTOMER",
      page: page,
      per_page: getNewPerPage,
      rowFilter: {
        $and: [getFilter],
      },
    };

    dispatch(getCashRequest(obj));
    setData(cashData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "getCashRequestList",
      module: "CUSTOMER",
      page: page,
      per_page: newPerPage,
      rowFilter: {
        $and: [getFilter],
      },
    };
    setNewPerPage(newPerPage);
    dispatch(getCashRequest(obj));
    setData(cashData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getCashRequestList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getCashRequest(obj));
  };

  useEffect(() => {
    loadInitialSuuplierData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cashData]);

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "getCashRequestList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
    };
    dispatch(getCashRequest(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //navigate
  const detailedPage = (customerID) => {
    dispatch(cashRequestNr(customerID));
    navigate(CustomerConstants.CUSTOMER_V2_CASH_REQUEST_UPDATE);
  };

  const [modalCashRequestShowStatus, setModalCashRequestShowStatus] =
    useState(false);

  /* show Cash request Modal Function */
  const showCashRequestModal = () => {
    setModalCashRequestShowStatus(true);
  };
  const hideModalStatus = () => {
    setModalCashRequestShowStatus(false); //hide cash request modal
  };
  const handleAdvanceSearchFuncApi = async (filters) => {
    let obj = {
      queryName: "getCashRequestList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: {
        $and: [filters],
      },
    };
    setFilter(filters);
    dispatch(getCashRequest(obj));
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Cash Request List</h2>
                <p className="subText">Cash Request List</p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={4} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i className="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />

            <Row>
              <Col xs={12} md={12} lg={12}>
                {filterShow && (
                  <CommonFilterCustomerV2
                    getfiltereddata={cashRequestInfo}
                    cancelAction={() => setFilterShow(!filterShow)}
                    onSubmit={(filters) => {
                      // console.log(">>Received filters from child:", filters);
                      // const filterData=[filters]
                      handleAdvanceSearchFuncApi(filters);
                      // You can now use the filters here
                    }}
                  />
                )}
              </Col>
            </Row>

            {/* user list */}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CL</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle"> Cash Request List</span>
                    </Col>
                    <Col xs={4} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        onClick={() => showCashRequestModal()}
                      >
                        Cash Request
                      </button>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={cashRequestInfo}
                          // data={filteredData}
                          data={data}
                          progressPending={cashData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={cashDataTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelect}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <CashRequestModel
        show={modalCashRequestShowStatus}
        onHide={() => hideModalStatus()}
      />
    </main>
  );
};

export default CashRequestList;
